export default "__VITE_ASSET__30dd8b28__"